import create from "zustand";
import { devtools } from "zustand/middleware"

import { SearchpolicyEnq, SearchpolicyEnq_DET, SearchpolicyEnq_RIDER, SearchpolicyEnq_NOMINEE, SearchpolicyEnq_FUND, SearchpolicyEnq_PREM } from '../api/search.policy.api'

const SearchPolicy = (set, get) => ({
	EnqResponse: null,
	
	EnqResponse_DET: null,
	EnqResponse_FUND: null,
	EnqResponse_RIDER: null,
	EnqResponse_NOMINEE: null,
	EnqResponse_PREM: null,

	Policy_n : null,

	EnqPolicyType: null,
	
	Enq: async (BType, enqType, value) => {
		await SearchpolicyEnq(BType, enqType, value).then((r) => {
			if(r.data.response_code === '01'){
				set({ EnqResponse: r.data.responseUtility })
			}else if(r.data.response_code === '02'){
				set({ EnqResponse: r.data.message })
			}else{
				set({ EnqResponse: null })
			}
		})
	},
	Enq_DET: async (value) => {

		set({ EnqResponse_DET: 'loading' })

		await SearchpolicyEnq_DET(value, get().EnqPolicyType).then((r) => {
			set({ EnqResponse_DET: 'loading' })
			if(r.data.response_code === '01'){
				set({ EnqResponse_DET: r.data.responseUtility })
			}else if(r.data.response_code === '02'){
				set({ EnqResponse_DET: r.data.message })
			}else{
				set({ EnqResponse_DET: null })
			}
		})
	},
	Enq_RIDER: async (value) => {
		
		set({ EnqResponse_RIDER: 'loading' })

		await SearchpolicyEnq_RIDER(value, get().EnqPolicyType).then((r) => { 
			if(r.data.response_code === '01'){
				set({ EnqResponse_RIDER: r.data.responseUtility })
			}else if(r.data.response_code === '02'){
				set({ EnqResponse_RIDER: r.data.message })
			}else{
				set({ EnqResponse_RIDER: null })
			}
		})
	},
	Enq_NOMINEE: async (value) => {
		
		set({ EnqResponse_NOMINEE: 'loading' })
		
		await SearchpolicyEnq_NOMINEE(value, get().EnqPolicyType).then((r) => { 			
			if(r.data.response_code === '01'){
				set({ EnqResponse_NOMINEE: r.data.responseUtility })
			}else if(r.data.response_code === '02'){
				set({ EnqResponse_NOMINEE: r.data.message })
			}else{
				set({ EnqResponse_NOMINEE: null })
			}
		})
	},
	Enq_FUND: async (value) => {
		
		set({ EnqResponse_FUND: 'loading' })
		
		await SearchpolicyEnq_FUND(value, get().EnqPolicyType).then((r) => { 
			if(r.data.response_code === '01'){
				set({ EnqResponse_FUND: r.data.responseUtility })
			}else if(r.data.response_code === '02'){
				set({ EnqResponse_FUND: r.data.message })
			}else{
				set({ EnqResponse_FUND: null })
			}
		})
	},
	Enq_PREM: async (value) => {

		set({ EnqResponse_PREM: 'loading' })
		
		await SearchpolicyEnq_PREM(value, get().EnqPolicyType).then((r) => {
			if(r.data.response_code === '01'){
				set({ EnqResponse_PREM: r.data.responseUtility })
			}else if(r.data.response_code === '02'){
				set({ EnqResponse_PREM: r.data.message })
			}else{
				set({ EnqResponse_PREM: null })
			}
		})
	},
	EnqNull: () =>{
		set({ 
			//EnqResponse: 		 null,
			EnqResponse_DET: 	 null,
			EnqResponse_FUND: 	 null,
			EnqResponse_RIDER: 	 null,
			EnqResponse_NOMINEE: null,
			EnqResponse_PREM: 	 null,
			//EnqPolicyType: 		 null,
		})

	}
});

const SearchPolicyStore = create(SearchPolicy);

export default SearchPolicyStore